<div class="row" class="row border Page-Header">
    <div class="col-12 p-0">
      <h6 class="HeadContent">Deferred Questions</h6>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
       <div class="row border-bottom">
         <div class="col-2 py-2 p-1">
           <div class="p-0">
             
             <select class="form-control form-control-sm"
             (change)="selectsubject($event)">
             <option selected value="0" hidden>Select Subject</option>
             <option class="border-bottom" *ngFor="let s of subject;let i=index" [value]="s.ID"> {{s.Name}}</option>
           </select>
           </div>
         
         </div>
   
   
    
       </div>
     </div>
   </div>
  <div class="row pt-1">
    <div class="col-12" *ngIf="QuestionStatusReport">
<app-tinyedneditor [QuestionStatusReport]="QuestionStatusReport"></app-tinyedneditor>
    </div>
  </div>
